import React from 'react';
import { BrandMark, Icon } from './Icons.jsx';
import { reportRuntimeIncident } from '../lib/runtimeLog.js';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, attempt: 0, retrying: false, error: null };
    this.timer = null;
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    reportRuntimeIncident({
      title: '界面模块异常，已自动隔离',
      detail: `${error?.message ?? error}${info?.componentStack ? ` · ${info.componentStack.split('\n')[1]?.trim() ?? ''}` : ''}`,
      action: 'Agent 正在尝试重建界面；若持续失败将保留物理仿真数据',
    });
    if (this.state.attempt < 1) {
      this.setState({ retrying: true });
      this.timer = window.setTimeout(() => {
        this.setState((previous) => ({
          hasError: false,
          retrying: false,
          attempt: previous.attempt + 1,
        }));
      }, 1400);
    }
  }

  componentWillUnmount() {
    if (this.timer) window.clearTimeout(this.timer);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-fallback">
          <div className="error-card">
            <BrandMark size={54} />
            <div className="eyebrow">AUTO-RECOVERY</div>
            <h1>{this.state.retrying ? '界面出现异常，正在自动重建…' : '界面模块未能恢复'}</h1>
            <p>
              {this.state.retrying
                ? '错误已被捕获并记录，诊断线程未受影响。1.4 秒后自动重试一次。'
                : '自动重试未能解决该问题。物理内核与教学 Agent 的单元测试仍然可用，可重新加载页面。'}
            </p>
            {this.state.error && (
              <details>
                <summary>查看错误详情</summary>
                <pre>{String(this.state.error?.stack ?? this.state.error)}</pre>
              </details>
            )}
            <div className="error-actions">
              <button type="button" className="primary-btn" onClick={() => window.location.reload()}>
                <Icon name="refresh" size={17} />
                重新加载
              </button>
              <button
                type="button"
                className="ghost-btn"
                onClick={() => this.setState({ hasError: false, retrying: false, attempt: 0 })}
              >
                再试一次
              </button>
            </div>
            {this.state.retrying && <div className="retry-progress" />}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
